
define(
	'Code25.CaterpartsGlobal.Related'
	, [
		'Code25.CaterpartsGlobal.Related.View'
	]
	, function (
		Code25STGlobalRelatedView
	) {
		'use strict';

		return {
			mount: function mount(container) {
				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');

				if (layout) {
					if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
						var ProductDetailsFullView = require('ProductDetails.Full.View');
						if (ProductDetailsFullView) {

							ProductDetailsFullView.childViews['Related.Items'] = function () {
								
								return new Code25STGlobalRelatedView({
									itemsIds: this.model.get('item').get('internalid'),
									application: container,
									related: true
								})
							};

							ProductDetailsFullView.childViews['Correlated.Items'] = function () {

								return new Code25STGlobalRelatedView({
									itemsIds: this.model.get('item').get('internalid'),
									application: container,
									correlated: true
								})
							};
						}
						var CartDetailedView = require('Cart.Detailed.View');
						if (CartDetailedView) {

							CartDetailedView.childViews['Related.Items'] = function (options) {

								return new Code25STGlobalRelatedView({
									itemsIds: options.model.getItemsIds(),
									application: container,
									related: true
								})
							};

							CartDetailedView.childViews['Correlated.Items'] = function (options) {

								return new Code25STGlobalRelatedView({
									itemsIds: options.model.getItemsIds(),
									application: container,
									correlated: true
								})
							};

							CartDetailedView.childViews['RecentlyViewed.Items'] = function (options) {

								return new Code25STGlobalRelatedView({
									itemsIds: options.model.getItemsIds(),
									application: container,
									recent: true
								})
							};
						}


						var FacetsItemCellView = require("Facets.ItemCell.View");

						_.extend(FacetsItemCellView.prototype, {

							getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (getContext) {
								var res = getContext.apply(this, _.rest(arguments));
								res.model = this.model;
								return res;
							})
						});

						var CartConfirmationView = require("Cart.Confirmation.View");
						CartConfirmationView.prototype.childViews['Related.Items'] = function (options) {
							
							var item = options.model.get("item");
							
							var relateditems_detail = item.get("relateditems_detail");
							var internalid=item.get("internalid");
							var matrix_parent = item.get("matrix_parent");
							if(matrix_parent){
								internalid=matrix_parent.get("internalid");
							}
							if (!relateditems_detail || relateditems_detail.length == 0) {
								
								if (matrix_parent) {
									relateditems_detail = matrix_parent.get("relateditems_detail")||[];
								}
							}
							console.log(relateditems_detail);
							console.log(internalid);
							
							return new Code25STGlobalRelatedView({
								itemsIds:internalid,
								application: container,
								related: true
							})
						};

					}
				}

			}
		};
	});
